import { render, staticRenderFns } from "./DemandeAdmissionInitiale.vue?vue&type=template&id=5b0327a3"
import script from "./DemandeAdmissionInitiale.vue?vue&type=script&lang=js"
export * from "./DemandeAdmissionInitiale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports